import { AdminMenuItem } from "./AdminMenuItem.js";
import { GetTeacherDataRequest, GetTeacherDataResponse, TeacherData, UserData, ClassData, CRUDClassRequest, CRUDUserRequest, CRUDResponse, GetClassesDataRequest, GetClassesDataResponse, ChangeClassOfStudentsRequest, ChangeClassOfStudentsResponse, type LastLoginUserData, type GetLastLoginDataRequest, type GetLastLoginDataResponse } from "./Data.js";
import { ajax, ajaxAsync } from "./communication/AjaxHelper.js";
import { Administration } from "./Administration.js";
import { PasswordPopup } from "./PasswordPopup.js";
import { w2alert, w2form, w2grid, w2popup, w2ui, w2utils } from 'w2ui'
import { StudentBulkImportMI } from "./StudentBulkImortMI.js";
import jQuery from 'jquery'
import { AdminMessages } from "./AdministrationMessages.js";
import { WorkspaceExporter } from "./workspaceexporter/WorkspaceImporterExporter.js";

import '/assets/css/overlay.css';


export class InactiveStudentsMI extends AdminMenuItem {

    studentGrid: w2grid;


    destroy() {
        this.studentGrid.destroy();
    }

    lastLoginUserData: LastLoginUserData[] = [];

    constructor(administration: Administration) {
        super(administration);
        this.identifier = "inactiveStudents";
    }

    checkPermission(user: UserData): boolean {
        return user.is_schooladmin;
    }

    getButtonIdentifier(): string {
        return AdminMessages.inactiveStudents();
    }

    async onMenuButtonPressed($mainHeading: JQuery<HTMLElement>, $tableLeft: JQuery<HTMLElement>,
        $tableRight: JQuery<HTMLElement>, $mainFooter: JQuery<HTMLElement>) {

        $mainHeading.html(AdminMessages.inactiveStudentsFooter());

        $tableRight.css('flex', '0');

        await this.fetchLastLoginData();

        this.studentGrid = new w2grid({
            name: "studentGrid",
            header: AdminMessages.students(),
            // selectType: "cell",
            show: {
                header: true,
                toolbar: true,
                toolbarDelete: true,
                footer: true,
                selectColumn: true,
                toolbarSearch: true
            },
            toolbar: {
                items: [
                    { type: 'break' },
                    { type: 'button', id: 'exportButton', text: AdminMessages.exportData() } //, img: 'fa-key' }
                ],
                onClick: (target, data) => {
                    if (target == "exportButton") {
                        this.exportSelectedWorkspacesToZipfile();
                    }
                }
            },
            recid: "id",
            columns: this.isVidisSchool() ?
                [
                    {
                        field: 'klasse', text: AdminMessages.classWord(), size: '10%', sortable: true, resizable: true
                    },
                    { field: 'username', text: AdminMessages.nickname(), size: '40%', sortable: true, resizable: true, editable: { type: 'text' }, sortMode: 'i18n' },
                    // { field: 'vidis_sub', text: AdminMessages.vidisID(), size: '25%', sortable: true, resizable: true, editable: { type: 'text' }, sortMode: 'i18n', hidden: !this.isVidisSchool()},
                    { field: 'vidis_akronym', text: AdminMessages.vidisAbbreviation(), size: '25%', sortable: true, resizable: true, editable: { type: 'text' }, sortMode: 'i18n' },
                    { field: 'vidis_klasse', text: AdminMessages.vidisClass(), size: '10%', sortable: true, resizable: true, editable: { type: 'text' }, sortMode: 'i18n' },
                    { field: 'inactiveSince', text: AdminMessages.inactiveSince(), size: '30%', sortable: true, resizable: true, sortMode: 'i18n' },
                ] :
                [
                    { field: 'id', text: 'ID', size: '20px', sortable: true, hidden: true },
                    {
                        field: 'klasse', text: AdminMessages.classWord(), size: '10%', sortable: true, resizable: true
                    },
                    { field: 'username', text: this.isVidisSchool() ? AdminMessages.nickname() : AdminMessages.username(), size: '40%', sortable: true, resizable: true, editable: { type: 'text' }, sortMode: 'i18n' },
                    { field: 'rufname', text: AdminMessages.firstName(), size: '25%', sortable: true, resizable: true, sortMode: 'i18n' },
                    { field: 'familienname', text: AdminMessages.lastName(), size: '25%', sortable: true, resizable: true, sortMode: 'i18n' },
                    { field: 'inactiveSince', text: AdminMessages.inactiveSince(), size: '30%', sortable: true, resizable: true, sortMode: 'i18n' },
                ],
            searches: [
                { field: 'username', label: this.isVidisSchool() ? AdminMessages.nickname() : AdminMessages.username(), type: 'text' },
                { field: 'rufname', label: AdminMessages.firstName(), type: 'text' },
                { field: 'familienname', label: AdminMessages.lastName(), type: 'text' }
            ],
            sortData: this.isVidisSchool() ?
                [{ field: 'inactiveSince', direction: 'desc' }, { field: 'username', direction: 'asc' }, { field: 'vidis_akronym', direction: 'asc' }]
                :
                [{ field: 'inactiveSince', direction: 'desc' }, { field: 'klasse', direction: 'asc' }, { field: 'familienname', direction: 'asc' }, { field: 'rufname', direction: 'asc' }],
            onDelete: (event) => { this.onDeleteStudent(event) },
        });

        this.studentGrid.add(this.lastLoginUserData);

        this.studentGrid.render($tableLeft[0]);

    }

    async fetchLastLoginData() {

        let request: GetLastLoginDataRequest = {};

        let response = await ajaxAsync("servlet/getLastLoginData", request) as GetLastLoginDataResponse;

        if (response.success) {
            response.userDataList.forEach((ud) => {
                ud.inactiveSince = this.twoDigits(ud.yearsSinceLastLogin) + " " + AdminMessages.yearsDative() + " " + this.twoDigits(ud.monthsSinceLastLogin) + " " + AdminMessages.monthsDative();
            });
            this.lastLoginUserData = response.userDataList;
        }

    }

    twoDigits(num: number): string {
        if (num < 10) return "0" + num;
        return "" + num;
    }

    async onDeleteStudent(event: any) {
        if (!event.detail.force || event.isStopped) return;

        let recIds: number[] = <number[]>this.studentGrid.getSelection();

        let request: CRUDUserRequest = {
            type: "delete",
            data: null,
            ids: recIds,
        }

        let response = await ajaxAsync("servlet/CRUDUser", request) as CRUDResponse;
        if (response.success) {
            recIds.forEach(id => this.studentGrid.remove("" + id));
        } else {
            w2alert(AdminMessages.errorDeletingStudents() + ": " + response.message);
            this.studentGrid.clear();
            await this.fetchLastLoginData();
            this.studentGrid.add(this.lastLoginUserData);
            this.studentGrid.refresh();
        }

        this.studentGrid.refresh();

    }

    exportSelectedWorkspacesToZipfile() {
        let recIds: number[] = <number[]>this.studentGrid.getSelection();
        if(recIds.length == 0) {
            w2alert(AdminMessages.noStudentsSelected());
            return;
        }
        let selectedUsers: LastLoginUserData[] = this.lastLoginUserData.filter(ud => recIds.includes(ud.id));
        WorkspaceExporter.exportAllWorkspacesToZipfile(selectedUsers);
    }
}